import globals from "imports/globals";
import $ from "cash-dom";
import "@lottiefiles/lottie-player";
import { gsapTrigger as WyPt, ScrollTween2 as ScrollTween } from "Utilities";

const layout = (function () {
    /**
     * Initialize Sticky Lottie instances
     */
    $(window).on("load", function () {
        if ($(".layout-sticky-lottie").length) {
            if (globals.debug) console.log("layout-sticky-lottie initialized");
            $(".layout-sticky-lottie").each(function () {
                var instance = $(this);
                var autoplay = instance[0].hasAttribute("data-autoplay");
                var player = instance.find("lottie-player")[0];
                var animation = player._lottie;
                var frameCount = player.getAttribute("data-frame-count");
                var keyframes = instance.find(".keyframe");
                var keyframeCount = keyframes.length;
                var keyframeIncrement = frameCount / keyframeCount;
                var frame = 0;

                if (!autoplay) {
                    keyframes.each(function (_i, _el) {
                        var caption = $(this).parents(".layout-sticky-lottie").find(".dynamic-caption");
                        var captionText = caption.find(".dynamic-caption-content");
                        var startFrame = parseInt($(this).attr("data-from")) || _i * keyframeIncrement;
                        var endFrame = parseInt($(this).attr("data-to")) || startFrame + keyframeIncrement;

                        new WyPt({
                            element: $(this)[0],
                            offset: {
                                top: "top-top",
                                bottom: "bottom-bottom",
                            },
                            callback: {
                                enter: function (_el, _dir) {
                                    if (_dir == "down") {
                                        var el = $(_el);
                                        var empty = el[0].hasAttribute("data-empty");
                                        if (!empty) {
                                            caption.addClass("on");
                                            globals.replaceText(_el, captionText);
                                        } else {
                                            caption.removeClass("on");
                                        }
                                    }
                                },
                                leave: function (_el, _dir) {
                                    if (_dir == "up") {
                                        var el = $(_el).prev();
                                        var empty = el[0].hasAttribute("data-empty");
                                        if (!empty) {
                                            caption.addClass("on");
                                            globals.replaceText(_el.previousElementSibling, captionText);
                                        } else {
                                            caption.removeClass("on");
                                        }
                                    }
                                },
                            },
                            // debug: true,
                        });

                        new ScrollTween({
                            element: $(this)[0],
                            from: "top-top",
                            to: "bottom-top",
                            callback: function (_n, _el) {
                                frame = startFrame + (endFrame - startFrame - 1) * _n;
                                /* 
                                console.log(
                                    _n,
                                    "frame: " + frame,
                                    "startFrame: " + startFrame,
                                    "endFrame: " + endFrame,
                                    "frameCount: " + frameCount,
                                    "keyframeCount: " + keyframeCount
                                );
                                */
                                animation.goToAndStop(frame, true);
                            },
                            // debug: true,
                        });

                        animation.goToAndStop(0, true);
                    });
                } else {
                    keyframes.each(function () {
                        var caption = $(this).parents(".layout-sticky-lottie").find(".dynamic-caption");
                        var captionText = caption.find(".dynamic-caption-content");
                        new WyPt({
                            element: $(this)[0],
                            offset: {
                                top: "top-top",
                                bottom: "bottom-bottom",
                            },
                            callback: {
                                enter: function (_el, _dir) {
                                    if (_dir == "down") {
                                        var el = $(_el);
                                        var from = el.attr("data-from");
                                        var to = el.attr("data-to");
                                        var speed = el.attr("data-speed") ? el.attr("data-speed") : 1.0;
                                        var empty = el[0].hasAttribute("data-empty");
                                        animation.setSpeed(parseFloat(speed));
                                        animation.playSegments([parseInt(from), parseInt(to)], true);
                                        if (!empty) {
                                            caption.addClass("on");
                                            globals.replaceText(_el, captionText);
                                        } else {
                                            caption.removeClass("on");
                                        }
                                    }
                                },
                                leave: function (_el, _dir) {
                                    if (_dir == "up") {
                                        var el = $(_el).prev();
                                        var from = el.attr("data-from");
                                        var to = el.attr("data-to");
                                        var speed = el.prev().attr("data-speed") ? el.prev().attr("data-speed") : 1.0;
                                        var empty = el[0].hasAttribute("data-empty");
                                        animation.setSpeed(parseFloat(speed));
                                        animation.playSegments([parseInt(from), parseInt(to)], true);
                                        if (!empty) {
                                            caption.addClass("on");
                                            globals.replaceText(_el.previousElementSibling, captionText);
                                        } else {
                                            caption.removeClass("on");
                                        }
                                    }
                                },
                            },
                            // debug: true,
                        });
                    });
                }
            });
        }
    });
})();

export default layout;
